import React, { useEffect } from 'react';
import {
  Redirect, Route, useLocation, useHistory,
} from 'react-router-dom';
import openCV from 'react-opencvjs';
import { useSelector } from 'react-redux';
import { isAuthenticated, isAdmin, isVerified } from '@redux/selectors/profile';

const Auth = React.lazy(() => import('@pages/auth/'));
const Home = React.lazy(() => import('@pages/home/'));
const Users = React.lazy(() => import('@pages/users/'));
const Hilal = React.lazy(() => import('@pages/hilal/'));
const Upload = React.lazy(() => import('@pages/upload/'));
const Detail = React.lazy(() => import('@pages/detail/'));
const Logout = React.lazy(() => import('@pages/Logout'));
const NotFound = React.lazy(() => import('@pages/notfound/'));

const PrivateRoute = ({ component: Component, roles, allowNonVerifyUser, ...rest }) => {
  const isAuth = useSelector(s => isAuthenticated(s));
  const history = useHistory();
  const location = useLocation();
  const is_admin = useSelector(s => isAdmin(s));
  const is_verified = useSelector(s => isVerified(s));

  useEffect(() => { openCV({ version: '4.5.1' }); }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuth) {
          return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
        }

        if (!allowNonVerifyUser && !is_verified) {
          history.push('/denied');
          return null;
        }

        if (!!roles && roles.indexOf('admin') !== -1 && !is_admin) {
          history.push('/denied');
          return null;
        }

        return <Component {...props} />;
      }}
    />
  );
};

const Root = () => {
  const isAuth = useSelector((s) => isAuthenticated(s));
  return <Redirect to={isAuth ? '/home' : '/login'} />;
};

const routes = [
  {
    path: '/logout',
    exact: true,
    component: Logout,
    route: Route,
  },
  {
    path: '/login',
    exact: true,
    component: Auth,
    route: Route,
  },
  {
    path: '/',
    exact: true,
    component: Root,
    route: Route,
  },
  {
    path: '/home',
    exact: true,
    component: Home,
    allowNonVerifyUser: true,
    route: PrivateRoute,
  },
  {
    path: '/hilal',
    exact: true,
    component: Hilal,
    route: PrivateRoute,
  },
  {
    path: '/hilal/:id',
    exact: true,
    component: Detail,
    route: PrivateRoute,
  },
  {
    path: '/upload',
    exact: true,
    component: Upload,
    route: PrivateRoute,
  },
  {
    path: '/users',
    exact: true,
    component: Users,
    roles: ['admin'],
    route: PrivateRoute,
  },
  {
    component: NotFound,
    route: Route,
  },
];

export { routes };
